import { render, staticRenderFns } from "./agreeText.vue?vue&type=template&id=6e0521ff"
import script from "./agreeText.vue?vue&type=script&lang=js"
export * from "./agreeText.vue?vue&type=script&lang=js"
import style0 from "./agreeText.vue?vue&type=style&index=0&id=6e0521ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.47.0_supports-color@_e2va3oitd2br7adsazclseazuu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports